module.exports = __webpack_public_path__ + "img/al_tape.e0db528a.png";